import React, { memo, useCallback, useState } from 'react'

import {
  BrainAIModel,
  Button,
  Check,
  ChevronDown,
  ChevronUp,
  ClosingDropdown,
  Icon,
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { iconSize } from 'Pods/ThreeDStudio/constants'

const MODELS = [
  { id: 'flux-dev', label: 'Flux Dev' },
  { id: 'flux-pro', label: 'Flux Pro' },
  { id: 'stable-diffusion', label: 'Stable Diffusion' },
]

const modelIcon = <Icon svgComponent={BrainAIModel} size={iconSize} color="dark" notSpaced />
const chevronUpIcon = <Icon svgComponent={ChevronUp} size={iconSize} color="dark" notSpaced />
const chevronDownIcon = <Icon svgComponent={ChevronDown} size={iconSize} color="dark" notSpaced />
const checkIcon = (
  <span className="model-selector__check">
    <Icon svgComponent={Check} size={iconSize} color="dark" notSpaced />
  </span>
)

function ModelSelector() {
  const [selectedId, setSelectedId] = useState(MODELS[0].id)
  const [isOpen, setIsOpen] = useState(false)
  const [triggerCloseDropdown, setTriggerCloseDropdown] = useState(false)

  const handleSelect = useCallback((id) => {
    setSelectedId(id)
    setTriggerCloseDropdown(true)
  }, [])

  const selected = MODELS.find(model => model.id === selectedId)

  const menu = (
    <ul className="model-selector__menu" role="listbox" aria-label="AI model">
      {MODELS.map(({ id, label }) => {
        const isSelected = id === selectedId
        return (
          <li
            key={id}
            className="model-selector__row"
            role="option"
            aria-selected={isSelected}
          >
            <Button
              type="ghost"
              size="small"
              variant="with-icon"
              actionType="button"
              customClass="model-selector__option cgt-body-base-semibold"
              trailIcon={isSelected ? checkIcon : null}
              onClick={() => handleSelect(id)}
            >
              {label}
            </Button>
          </li>
        )
      })}
    </ul>
  )

  return (
    <ClosingDropdown
      content={menu}
      isSimpleContent
      size="medium"
      placement="top-start"
      contentClassName="model-selector__popover"
      className="model-selector"
      triggerCloseDropdown={triggerCloseDropdown}
      setTriggerCloseDropdown={setTriggerCloseDropdown}
      onOpenChange={setIsOpen}
    >
      <Button
        type="secondary"
        size="small"
        variant="with-icon"
        actionType="button"
        icon={modelIcon}
        trailIcon={isOpen ? chevronUpIcon : chevronDownIcon}
        customClass={classnames(
          'model-selector__trigger cgt-button-text-base-semibold',
          isOpen && 'model-selector__trigger--open',
        )}
        aria-label={`AI model (${selected.label})`}
        aria-haspopup="listbox"
        aria-expanded={isOpen}
      >
        {selected.label}
      </Button>
    </ClosingDropdown>
  )
}

export default memo(ModelSelector)
